import Flex from './Flex';
import FlexItem from './FlexItem';
Flex.Item = FlexItem;
export default Flex;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/antd-mobile/es/flex/index.js
// module id = 317
// module chunks = 0